import React from 'react'
import Dropdown from './dropdown.png'

function DropDownButton() {

    function myFunction2() {
        document.getElementById("drop").classList.toggle("show");
      }

    return (
        <div>
            <div class="dropdown">
                <button onclick={() => {myFunction2()}}></button>
                <a id="drop"><img className="nav-mobile-button dropbtn2" src={Dropdown}></img></a>
                <div id="myDropdownNav" class="dropdown-content">
                    <a href="#">Link 1</a>
                    <a href="#">Link 2</a>
                    <a href="#">Link 3</a>
                </div>
            </div>
        </div>
    )
}

export default DropDownButton
